export async function copyTextToClipboard(text: string) {
  if ('clipboard' in navigator) {
    await navigator.clipboard.writeText(text);
  } else {
    document.execCommand('copy', true, text);
  }
}

export async function copyElementContentToClipboard(el: HTMLElement) {
  if ('clipboard' in navigator) {
    navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': el.innerText,
        'text/html': el.innerHTML,
      }),
    ]);
  } else {
    copyTextToClipboard(el.innerText);
  }
}
